<!-- Footer -->
<div class="footer-box">
  <footer class="page-footer font-small">
    <!-- Copyright -->
    <div class="footer-copyright text-center py-3">
      <img width="100px" src="assets/img/Logo-Isstec_gris.png" alt="LOGO" />
    </div>
    <!-- Copyright -->
  </footer>
</div>

<!-- Footer -->
